/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
import React, { useEffect, useMemo } from 'react'
import { compose, withApollo } from 'react-apollo'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { useHistory, withRouter } from 'react-router-dom'
import moment from 'moment'

import {
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  Avatar,
} from 'antd'

import currentUserQuery from '../graphql/queries/currentUser'
import updateUserMutation from '../graphql/mutations/updateUser'
import { useMultiState } from '../hooks'

import Header from './header'

import {
  ProfileStyled,
  RunnerStyled,
  ProfileImgStyled,
} from './styled-components/profileStyled'
import './css/profile.css'

// const { Content } = Layout;
const initialState = {
  signupLoading: false,
  disabled: true,

}
const ProfileContainer = (props) => {
  const [state, setState] = useMultiState(initialState)
  const history = useHistory()
  const { client } = props
  const FormItem = Form.Item
  const { getFieldDecorator, setFieldsValue } = props.form
  const { Option } = Select
  const { loading, data } = useQuery(currentUserQuery, { client, fetchPolicy: 'network-only' })
  const [updateUser] = useMutation(updateUserMutation, { client })

  const profilePicture = useMemo(() => {
    if (!loading && data.currentUser) {
      if (data.currentUser.profile.imageUrl) {
        return (<img src={data.currentUser.profile.imageUrl} className="img-runner" alt="img-runner" />)
      }
    }
    return (<Avatar size={250} style={{ backgroundColor: '#87d068' }} icon="user" />)
  }, [data])
  const handleSubmit = (e) => {
    e.preventDefault()
    const { validateFields } = props.form
    setState({ signupLoading: true })
    validateFields((err, values) => {
      if (err) {
        console.error(err)
        setState({ signupLoading: false })
      } else {
        updateUser(
          {
            variables: {
              record: {
                _id: data.currentUser._id,
                ...values,
              },
            },
          }
        ).then(() => {
          history.push('/home')
        })
      }
    })
  }
  useEffect(() => {
    const getCurrentUser = async () => {
      try {
        if (loading === false) {
          setState({ disabled: false })
          if (data.currentUser === null) {
            history.push('/login')
          }
          const { profile, email } = data.currentUser
          setFieldsValue(
            {
              profile:
              {
                firstName: profile.firstName,
                lastName: profile.lastName,
                gender: profile.gender,
                birthDate: moment(profile.birthDate),
                nationality: profile.nationality,
                telephone: profile.telephone,

              },
              email,

            }
          )
        }
      } catch (err) {
        console.error(err)
      } finally {
        setState({ signupLoading: false })
      }
    }
    getCurrentUser()
  }, [client, data, loading, setFieldsValue])
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  }
  return (
    <div>
      <Header />
      <ProfileStyled>
        <RunnerStyled>
          <ProfileImgStyled>
            {profilePicture}
          </ProfileImgStyled>
          <Col>
            <Form {...formItemLayout} onSubmit={handleSubmit}>
              <div className="data-text">
                ข้อมูลทั่วไป
              </div>
              <FormItem label="FistName" hasFeedback>
                {getFieldDecorator('profile.firstName', {
                  rules: [
                    {
                      required: true,
                      message: 'Please input your first name!',
                    },
                    {
                      message: 'Please input your first name!',
                    },
                  ],
                })(<Input placeholder="First Name" />)}
              </FormItem>

              <FormItem label="LastName" hasFeedback>
                {getFieldDecorator('profile.lastName', {
                  rules: [
                    {
                      required: true,
                      message: 'Please input your last name!',
                    },
                    {
                      message: 'Please input your last name!',
                    },
                  ],
                })(<Input placeholder="Last Name" />)}
              </FormItem>
              <FormItem label="E-mail" hasFeedback>
                {getFieldDecorator('email', {
                  rules: [
                    {
                      type: 'email',
                      message: 'The input is not valid E-mail!',
                    },
                    {
                      required: true,
                      message: 'Please input your E-mail!',
                    },
                  ],
                })(<Input placeholder="Email" />)}
              </FormItem>
              <FormItem label="Telephone" hasFeedback>
                {getFieldDecorator('profile.telephone', {
                  rules: [
                    {
                      pattern: new RegExp('^[0-9+]+$'),
                      message: 'The input is not valid Phone Number!',
                    },
                    {
                      required: true,
                      message: 'Please input your Phone Number!',
                    },
                  ],
                })(<Input placeholder="Phone Number" />)}
              </FormItem>
              <FormItem label="Gender" hasFeedback>
                {getFieldDecorator('profile.gender', {
                  rules: [
                    { required: true, message: 'Please select your gender!' },
                  ],
                })(
                  <Select placeholder="Gender">
                    <Option value="male">male</Option>
                    <Option value="female">female</Option>
                  </Select>
                )}
              </FormItem>
              <FormItem label="BirthDate" hasFeedback>
                {getFieldDecorator('profile.birthDate')(
                  <DatePicker placeholder="Birthday" style={{ width: '200' }} />
                )}
              </FormItem>
              <div className="loginTextField">
                <FormItem label="Nationality">
                  {getFieldDecorator('profile.nationality', {})(
                    <Input placeholder="Nationality" />
                  )}
                </FormItem>
              </div>
              <div className="loginTextField">
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  loading={state.signupLoading}
                  style={{ float: 'right' }}
                >
              Done
                </Button>
              </div>
            </Form>
          </Col>
        </RunnerStyled>
      </ProfileStyled>
    </div>
  )
}

export default compose(
  Form.create(),
  withApollo,
  withRouter
)(ProfileContainer)



// WEBPACK FOOTER //
// ./src/components/editProfile.js